// A value that settles: it follows `value`, but only after `delayMs` has passed
// with no further change.
//
// For a control whose input drives a NETWORK read rather than a local filter. The
// control itself stays fully live — it renders the raw value on every keystroke,
// so typing never feels laggy — while the query key downstream moves once the
// customer pauses, which is what stops a six-character search from being six
// requests whose answers race each other back.
//
// Returns the first value immediately: an initial render has nothing to settle,
// and delaying it would leave the picker empty for the delay on open.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return settled;
}
